"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.useRimSearchByCarStore = void 0;
/* eslint-disable no-useless-catch */
const pinia_1 = require("pinia");
const interfaces_1 = require("./interfaces");
const Cache_1 = require("./Cache");
const DropdownInputItem_1 = __importDefault(require("../../components/Form/DropdownInput/DropdownInputItem"));
const fetch_1 = __importDefault(require("../../common/utils/fetch"));
const ShopConfig_1 = require("../../common/utils/ShopConfig");
const alcarSearchUrl = ShopConfig_1.ShopConfig.getAlcarSearchHost();
const sizeRegex = /^([0-9]+)\/([0-9]+)[R|\s]?([0-9]+)/i;
exports.useRimSearchByCarStore = (0, pinia_1.defineStore)("rimSearchByCar", {
    state: () => ({
        cache: new Cache_1.Cache(),
        carForm: {
            carBrand: null,
            carType: null,
            carModel: null,
            carBrands: [],
            carTypes: [],
            carModels: [],
            carRims: [],
            filteredRims: [],
            rimSizes: {},
            rimSize: null,
            rimTpmss: {},
            rimTpms: null,
        },
        selectedRim: undefined,
    }),
    actions: {
        rewindTo(step) {
            switch (step) {
                case interfaces_1.CarFormStep.Brand:
                    this.carForm.carTypes = [];
                    this.carForm.carType = null;
                // falls through
                case interfaces_1.CarFormStep.Type:
                    this.carForm.carModels = [];
                    this.carForm.carModel = null;
                // falls through
                case interfaces_1.CarFormStep.Model:
                    this.carForm.filteredRims = [];
                    this.carForm.carRims = [];
                    this.carForm.rimSizes = {};
                    this.carForm.rimSize = null;
                    this.carForm.rimTpmss = {};
                    this.carForm.rimTpms = null;
                    this.selectedRim = undefined;
                    break;
            }
        },
        selectRim(id) {
            const rims = this.carForm.carRims.filter((rim) => rim.Article === id);
            if (rims.length) {
                this.selectedRim = rims[rims.length - 1];
            }
        },
        setCarRims(rims) {
            this.carForm.carRims = rims;
            this.carForm.filteredRims = [];
            this.carForm.carRims.forEach((rim) => {
                this.carForm.filteredRims.push(rim.Article);
            });
            this.calculateTpmsAndSizes();
            if (this.carForm.filteredRims.length > 0) {
                this.selectRim(this.carForm.filteredRims[0]);
            }
        },
        calculateTpmsAndSizes() {
            this.carForm.rimTpmss.hasTpms = [];
            this.carForm.rimTpmss.noTpms = [];
            this.carForm.rimTpms = null;
            this.carForm.rimSize = null;
            if (this.carForm.carRims.length === 0) {
                return;
            }
            this.carForm.carRims.forEach((rim) => {
                // TPMS
                if (rim.TPMSLine !== false) {
                    rim.TPMSLine.forEach((tpms) => {
                        if (this.cache.hasValveCache(tpms.Article)) {
                            const valve = this.cache.readValveCache(tpms.Article);
                            if (valve !== undefined) {
                                if (!rim.valves) {
                                    rim.valves = [];
                                }
                                rim.valves.push(valve);
                            }
                        }
                    });
                    if (!this.carForm.rimTpmss.hasTpms) {
                        this.carForm.rimTpmss.hasTpms = [];
                    }
                    this.carForm.rimTpmss.hasTpms.push(rim.Article);
                }
                else {
                    if (!this.carForm.rimTpmss.noTpms) {
                        this.carForm.rimTpmss.noTpms = [];
                    }
                    this.carForm.rimTpmss.noTpms.push(rim.Article);
                }
                // Sizes
                if (Array.isArray(rim.TyreLine) && rim.TyreLine.length) {
                    rim.TyreLine.forEach((tyre) => {
                        const sizeMatch = sizeRegex.exec(tyre.Tyre);
                        if (sizeMatch && sizeMatch[3]) {
                            const size = sizeMatch[3];
                            if (!this.carForm.rimSizes[size]) {
                                this.carForm.rimSizes[size] = [];
                            }
                            if (!this.carForm.rimSizes[size].includes(rim.Article)) {
                                this.carForm.rimSizes[size].push(rim.Article);
                            }
                        }
                    });
                }
            });
        },
        rimSizeChanged() {
            this.carForm.filteredRims = this.filterRims();
            if (this.selectedRim !== undefined &&
                !this.carForm.filteredRims.includes(this.selectedRim.Article)) {
                this.selectedRim = undefined;
            }
            if (this.selectedRim === undefined &&
                this.carForm.filteredRims.length > 0) {
                this.selectRim(this.carForm.filteredRims[0]);
            }
        },
        rimTpmsChanged() {
            this.carForm.filteredRims = this.filterRims();
            if (this.selectedRim !== undefined &&
                !this.carForm.filteredRims.includes(this.selectedRim.Article)) {
                this.selectedRim = undefined;
            }
            if (this.selectedRim === undefined &&
                this.carForm.filteredRims.length > 0) {
                this.selectRim(this.carForm.filteredRims[0]);
            }
        },
        filterRims() {
            let rims = [];
            if (this.carForm.rimSize === null) {
                this.carForm.carRims.forEach((rim) => {
                    rims.push(rim.Article);
                });
            }
            else {
                rims = this.carForm.rimSizes[this.carForm.rimSize] || [];
            }
            if (this.carForm.rimTpms === interfaces_1.TpmsEnum.NO_TPMS) {
                rims = rims.filter((key) => { var _a; return (_a = this.carForm.rimTpmss[interfaces_1.TpmsEnum.NO_TPMS]) === null || _a === void 0 ? void 0 : _a.includes(key); });
            }
            if (this.carForm.rimTpms === interfaces_1.TpmsEnum.HAS_TPMS) {
                rims = rims.filter((key) => { var _a; return (_a = this.carForm.rimTpmss[interfaces_1.TpmsEnum.HAS_TPMS]) === null || _a === void 0 ? void 0 : _a.includes(key); });
            }
            return rims;
        },
        hasValveStockDetailsLoaded(id) {
            let found = false;
            const valves = this.cache.readValveCacheAll();
            if (valves.size) {
                valves.forEach((item) => {
                    var _a, _b;
                    if (item.id === id && ((_b = (_a = item.stocks) === null || _a === void 0 ? void 0 : _a.stockDetails) === null || _b === void 0 ? void 0 : _b.length)) {
                        found = true;
                    }
                });
            }
            return found;
        },
        hasRimStockDetailsLoaded(id) {
            let found = false;
            this.carForm.carRims.forEach((item) => {
                var _a, _b;
                if (item.id === id && ((_b = (_a = item.stocks) === null || _a === void 0 ? void 0 : _a.stockDetails) === null || _b === void 0 ? void 0 : _b.length)) {
                    found = true;
                }
            });
            return found;
        },
        async loadBrands(router) {
            // "/user-cars/alcar-api?nextFilter=brands"
            try {
                const response = await fetch(alcarSearchUrl +
                    router.resolve({
                        name: "alcar_api",
                        query: {
                            'nextFilter': 'brands'
                        }
                    }).href);
                const brands = await response.json();
                this.carForm.carBrands = [];
                brands.forEach((brand) => {
                    this.carForm.carBrands.push(new DropdownInputItem_1.default(brand.BrandCode, brand.BrandText));
                });
            }
            catch (error) {
                console.error("Error loading brands:", error);
                throw error;
            }
        },
        async loadTypes(router) {
            // "/user-cars/alcar-api?nextFilter=types&filters[brandcode]=%brandCode%"
            if (this.carForm.carBrand === null)
                return;
            try {
                const response = await fetch(alcarSearchUrl +
                    router.resolve({
                        name: 'alcar_api',
                        query: {
                            'nextFilter': 'types',
                            'filters[brandcode]': this.carForm.carBrand
                        }
                    }).href);
                const types = await response.json();
                this.carForm.carTypes = [];
                types.forEach((type) => {
                    this.carForm.carTypes.push(new DropdownInputItem_1.default(type.TypeCode, type.TypeText));
                });
            }
            catch (error) {
                console.error("Error loading types:", error);
                throw error;
            }
        },
        async loadModels(router) {
            // "/user-cars/alcar-api?nextFilter=models&filters[brandcode]=%brandCode%&filters[typecode]=%typeCode%"
            if (this.carForm.carBrand === null || this.carForm.carType === null)
                return;
            try {
                const response = await fetch(alcarSearchUrl +
                    router.resolve({
                        name: 'alcar_api',
                        query: {
                            'nextFilter': 'models',
                            'filters[brandcode]': this.carForm.carBrand,
                            'filters[typecode]': this.carForm.carType
                        }
                    }).href);
                const models = await response.json();
                this.carForm.carModels = [];
                models.forEach((model) => {
                    this.carForm.carModels.push(new DropdownInputItem_1.default(model.ModelCode, model.ModelName));
                });
            }
            catch (error) {
                console.error("Error loading models:", error);
                throw error;
            }
        },
        async loadRims(router) {
            // "/user-cars/alcar-api?nextFilter=sizes&filters[modelcode]=%modelCode%"
            if (this.carForm.carModel === null)
                return;
            try {
                const response = await (0, fetch_1.default)(router.resolve({
                    name: "shop_products_alcar_rims",
                    params: {
                        alcarModelCode: this.carForm.carModel,
                    },
                }).href, {
                    method: "GET",
                    headers: {
                        "Accept": "application/json",
                    },
                });
                const rims = [];
                const tpmsIds = [];
                if (response.length) {
                    response.forEach((rim) => {
                        rims.push(rim);
                        if (rim.TPMSLine !== false) {
                            rim.TPMSLine.forEach((item) => {
                                if (typeof item.Article === "string" && item.Article) {
                                    if (!tpmsIds.includes(item.Article)) {
                                        tpmsIds.push(item.Article);
                                    }
                                }
                            });
                        }
                    });
                }
                this.cache.emptyValveCache();
                if (tpmsIds.length) {
                    const valveResponse = await (0, fetch_1.default)(router.resolve({ name: "shop_products_get_valves" }).href, {
                        method: "POST",
                        body: JSON.stringify({ manufacturerSku: tpmsIds }),
                        headers: {
                            "Accept": "application/json",
                        }
                    });
                    if (valveResponse.length > 0) {
                        valveResponse.forEach((item) => {
                            this.cache.addValveCache(item);
                        });
                    }
                }
                this.setCarRims(rims);
            }
            catch (error) {
                throw error;
            }
        },
        async showStockDetails(router, id) {
            const rim = this.carForm.carRims.find(item => item.id === id);
            if (!rim)
                return;
            if (this.hasRimStockDetailsLoaded(id)) {
                rim.stocks.stockDetailsStatus = "";
                return;
            }
            rim.stocks.stockDetailsStatus = "details-loading";
            try {
                const response = await (0, fetch_1.default)(router.resolve({ name: "shop_products_stock_details", params: { id } }).href);
                if (Array.isArray(response) && response.length) {
                    rim.stocks.stockDetails = response;
                }
                rim.stocks.stockDetailsStatus = "";
            }
            catch (error) {
                console.error("Error loading rim stock details:", error);
                throw error;
            }
        },
        hideStockDetails(id) {
            this.carForm.carRims.forEach((item) => {
                if (item.id === id) {
                    item.stocks.stockDetailsStatus = "hidden";
                }
            });
        },
        async showValveStockDetails(router, id) {
            const valve = this.cache.readValveCacheAll().get(id);
            if (!valve)
                return;
            if (this.hasValveStockDetailsLoaded(id)) {
                valve.stocks.stockDetailsStatus = "";
                return;
            }
            valve.stocks.stockDetailsStatus = "details-loading";
            try {
                const response = await (0, fetch_1.default)(router.resolve({ name: "shop_products_stock_details", params: { id } }).href);
                if (Array.isArray(response) && response.length) {
                    valve.stocks.stockDetails = response;
                }
                valve.stocks.stockDetailsStatus = "";
            }
            catch (error) {
                console.error("Error loading valve stock details:", error);
                throw error;
            }
        },
        hideValveStockDetails(id) {
            const valve = this.cache.readValveCacheAll().get(id);
            if (valve) {
                valve.stocks.stockDetailsStatus = "hidden";
            }
        }
    },
});
